<script setup lang="ts">
const data = [
	{
		translation_key_name: 'name_1',
		translation_key_description: 'description_1',
		icon: 'shower',
	},
	{
		translation_key_name: 'name_2',
		translation_key_description: 'description_2',
		icon: 'routing-2',
	},
	{
		translation_key_name: 'name_3',
		translation_key_description: 'description_3',
		icon: 'break',
	},
	{
		translation_key_name: 'name_4',
		translation_key_description: 'description_4',
		icon: 'task-square',
	},
	{
		translation_key_name: 'name_5',
		translation_key_description: 'description_5',
		icon: 'shield-tick',
	},
	{
		translation_key_name: 'name_6',
		translation_key_description: 'description_6',
		icon: 'driving',
	},
	{
		translation_key_name: 'name_1',
		translation_key_description: 'description_1',
		icon: 'shower',
	},
	{
		translation_key_name: 'name_2',
		translation_key_description: 'description_2',
		icon: 'routing-2',
	},
	{
		translation_key_name: 'name_3',
		translation_key_description: 'description_3',
		icon: 'break',
	},
	{
		translation_key_name: 'name_4',
		translation_key_description: 'description_4',
		icon: 'task-square',
	},
	{
		translation_key_name: 'name_5',
		translation_key_description: 'description_5',
		icon: 'shield-tick',
	},
	{
		translation_key_name: 'name_6',
		translation_key_description: 'description_6',
		icon: 'driving',
	},
]
</script>

<template>
	<section class="benefits">
		<div class="benefits__title-wrap">
			<h3 data-aos="fade-up" class="benefits__title">{{ $t('modules.long_term_page_module.long_term_page_benefits.additional_benefits') }}</h3>
		</div>
		<div class="benefits__carousel">
			<div class="benefits__carousel-container">
				<div v-for="(item, idx) in data" :key="idx" class="benefits__item">
					<GlobalIcon class="benefits__item-icon" :name="item.icon" :width="20" />
					<p class="benefits__item-name">{{ $t(`modules.long_term_page_module.long_term_page_benefits.${item.translation_key_name}`) }}</p>
					<p class="benefits__item-description">
						{{ $t(`modules.long_term_page_module.long_term_page_benefits.${item.translation_key_description}`) }}
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped lang="scss">
@import './LongTermPageBenefits.scss';
</style>
